import { useEffect, useState } from "react";

const STORAGE_KEY = "ca_floats_hidden";
const EVENT = "ca:floats:toggle";

/**
 * Global "hide all floating buttons" toggle.
 *
 * Backed by localStorage so the preference persists across reloads.
 * Other components subscribe to a custom DOM event to update without
 * needing a global context.
 *
 * Returns { hidden, toggle, hide, show }.
 */
export const useFloatsVisibility = () => {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
  });
  useEffect(() => {
    const onEvent = (e) => setHidden(Boolean(e.detail?.hidden));
    window.addEventListener(EVENT, onEvent);
    return () => window.removeEventListener(EVENT, onEvent);
  }, []);
  const setHiddenPersist = (val) => {
    try {
      if (val) localStorage.setItem(STORAGE_KEY, "1");
      else localStorage.removeItem(STORAGE_KEY);
    } catch { /* noop */ }
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { hidden: val } }));
    setHidden(val);
  };
  return {
    hidden,
    toggle: () => setHiddenPersist(!hidden),
    hide: () => setHiddenPersist(true),
    show: () => setHiddenPersist(false),
  };
};
